import * as THREE from 'three';

export abstract class Loader {
	static textureLoader = new THREE.TextureLoader();

	static loadTexture(src: string, callback?: (data: THREE.Texture) => void) {
		return this.textureLoader.load(src, callback);
	}
}
